"use client";
import { Color } from "@/__generated__/graphql";
import {
  productsCategoriesSearchParamsSchema,
  productsCategoriesSearchParamsSchemaDefaults,
} from "@/app/(main)/categories/[...slugs]/ProductsCategoriesSearchParamsSchema";
import Arrow2DownIcon from "@/app/_components/Icons/Arrow2DownIcon";
import Arrow2LeftIcon from "@/app/_components/Icons/Arrow2LeftIcon";
import { useQueryParams } from "@/lib/useQueryParams";
import { Box, Card, CardActionArea, CardContent, Collapse, Icon, Stack, Typography } from "@mui/material";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useState } from "react";
import { useSiteSearchContext } from "../SiteSearchContext";
import _ from "lodash";
function ColorBox({ color, selected, onChange }: { color: Color; selected: boolean; onChange: (id: number) => void }) {
  return (
    <Box
      onClick={() => {
        onChange(color.id);
      }}
      sx={(t) => {
        return {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          borderRadius: 2,
          boxSizing: "border-box",
          boxShadow: `inset 0 0 ${selected ? 3 : 1}px 1px ${selected ? t.palette.secondary.main : t.palette.grey["100"]}`,
          gap: 0.5,
          p: 0.5,
          pr: 0.5,
          transition: "0.2s all",
          cursor: "pointer",
        };
      }}
    >
      <Card
        elevation={0}
        sx={{
          borderRadius: 2,
          width: 22,
          height: 22,
          background: color.hex,
        }}
      ></Card>
      <Typography variant="caption">{color.title}</Typography>
    </Box>
  );
}
export default function ColorsSideFilter({ intiOpen }: { intiOpen?: boolean }) {
  const { colors, selectedColors, handleColorsChange } = useSiteSearchContext();

  const [open, setOpen] = useState(intiOpen ?? false);

  return (
    <>
      <Box
        sx={{
          borderRadius: 2,
        }}
      >
        <Card
          elevation={0}
          sx={{
            borderRadius: 0,
          }}
        >
          <CardActionArea
            onClick={(ev) => {
              setOpen((e) => !e);
              // handleScrollToChartsCommunity(ev);
            }}
            sx={{
              p: {
                md: 2,
                xs: 1,
              },
            }}
          >
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
              <Typography variant="subtitle1">رنگ ها</Typography>
              <Icon color="secondary" fontSize="small">
                {!open ? <Arrow2LeftIcon /> : <Arrow2DownIcon />}
              </Icon>
            </Stack>
          </CardActionArea>
          <Collapse in={open}>
            <CardContent sx={{ maxHeight: 350, overflow: "auto" }} className="custom-scrollbar">
              <Stack
                spacing={{ xs: 1, sm: 2, md: 1 }}
                direction="row"
                alignItems={"center"}
                justifyContent={"start"}
                useFlexGap
                sx={{ flexWrap: "wrap" }}
              >
                {colors &&
                  colors.map((color, index) => {
                    const isSelected = Boolean(selectedColors && selectedColors.includes(color.id));
                    return (
                      <ColorBox
                        key={index}
                        color={color}
                        selected={isSelected}
                        onChange={(id) => {
                          let newValues: number[] | null | undefined = selectedColors;
                          if (isSelected) {
                            if (newValues && newValues.includes(id)) {
                              const indexColorToRemove = newValues.findIndex((a) => a === id);
                              if (indexColorToRemove > -1) {
                                newValues.splice(indexColorToRemove, 1);
                              }
                            }
                          } else {
                            if (newValues) {
                              newValues.push(id);
                            } else {
                              newValues = [id];
                            }
                          }

                          if (!newValues || newValues.length <= 0) {
                            newValues = undefined;
                          }

                          handleColorsChange(_.uniq(newValues), false);
                        }}
                      ></ColorBox>
                    );
                  })}
              </Stack>
            </CardContent>
          </Collapse>
        </Card>
      </Box>
    </>
  );
}
